var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("销售订单")]), _vm._l(_vm.displayData, function (d) {
    return _c('div', {
      staticClass: "section-block"
    }, [_c('h3', {
      staticClass: "block-title"
    }, [_vm._v(_vm._s(d.title))]), _c('div', {
      class: {
        'block-displaycontent': true,
        'block-displaycontent-editable': !d.lock && _vm.fieldEditing !== d.key
      },
      on: {
        "click": function ($event) {
          !d.lock && _vm.fieldEditing !== d.key && _vm.editField(d.key, d.type);
        }
      }
    }, [_vm.fieldEditing !== d.key ? _c('span', {
      staticClass: "block-displaytext"
    }, [_vm._v(" " + _vm._s(_vm.displayText[d.key] || "-") + " ")]) : _c('div', [d.type === 'Number' ? _c('InputNumber', {
      ref: d.key,
      refInFor: true,
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "min": 0,
        "disabled": !(_vm.user.superAdmin || _vm.arrayIntersection(['allFactoryLeader', 'sales', 'factoryLeader'], _vm.user.simpleRole).length > 0) || _vm.salesOrder.startedAt
      },
      model: {
        value: _vm.updateContent.volPlan,
        callback: function ($$v) {
          _vm.$set(_vm.updateContent, "volPlan", $$v);
        },
        expression: "updateContent.volPlan"
      }
    }) : d.type === 'DateTime' ? _c('div', [_c('DatePicker', {
      staticStyle: {
        "width": "120px"
      },
      attrs: {
        "type": "date",
        "options": _vm.planArrivedAtOptions,
        "disabled": !(_vm.user.superAdmin || _vm.arrayIntersection(['allFactoryLeader', 'sales', 'factoryLeader'], _vm.user.simpleRole).length > 0) || _vm.salesOrder.startedAt
      },
      model: {
        value: _vm.updateContent.date,
        callback: function ($$v) {
          _vm.$set(_vm.updateContent, "date", $$v);
        },
        expression: "updateContent.date"
      }
    }), _c('Select', {
      staticStyle: {
        "margin-left": "8px",
        "width": "80px"
      },
      attrs: {
        "filterable": "",
        "disabled": !(_vm.user.superAdmin || _vm.arrayIntersection(['allFactoryLeader', 'sales', 'factoryLeader'], _vm.user.simpleRole).length > 0) || _vm.salesOrder.startedAt
      },
      model: {
        value: _vm.updateContent.time,
        callback: function ($$v) {
          _vm.$set(_vm.updateContent, "time", $$v);
        },
        expression: "updateContent.time"
      }
    }, _vm._l(_vm.timeOptions, function (time) {
      return _c('Option', {
        key: time.label,
        attrs: {
          "value": time.label
        }
      }, [_vm._v(_vm._s(time.label))]);
    }), 1)], 1) : d.type === 'TextArea' ? _c('Input', {
      attrs: {
        "type": "textarea",
        "rows": 3,
        "disabled": !(_vm.user.superAdmin || _vm.arrayIntersection(['allFactoryLeader', 'sales', 'factoryLeader'], _vm.user.simpleRole).length > 0) || _vm.salesOrder.startedAt,
        "placeholder": "输入备注..."
      },
      model: {
        value: _vm.updateContent.remark,
        callback: function ($$v) {
          _vm.$set(_vm.updateContent, "remark", $$v);
        },
        expression: "updateContent.remark"
      }
    }) : _c('span', [_vm._v("编辑出错")])], 1)]), _vm.fieldEditing === d.key ? _c('div', {
      staticStyle: {
        "margin": "4px 0 0 130px"
      }
    }, [_c('Button', {
      staticStyle: {
        "width": "64px"
      },
      attrs: {
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function ($event) {
          return _vm.fieldEditSave();
        }
      }
    }, [_vm._v("保存")]), _c('Button', {
      staticStyle: {
        "margin-left": "8px"
      },
      attrs: {
        "size": "small"
      },
      on: {
        "click": function ($event) {
          _vm.fieldEditing = null;
        }
      }
    }, [_vm._v("取消")])], 1) : _vm._e()]);
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }